function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { Button } from '@signicat/designi/components/buttons';
import { TextField, Select, DateField, Toggle } from '@signicat/designi/components/inputs';
import { Form, Field } from '@signicat/designi/components/forms';
import { Segment } from '@signicat/designi/components/containers';
import { Column, Flex, Grid, Row } from '@signicat/designi/components/layout';
import { Heading, HelpText } from '@signicat/designi/components/text';
import { Modal } from '@signicat/designi/components/overlays';
import { Spinner } from '@signicat/designi/components/loaders';
import { Message } from '@signicat/designi/components/messages';
import { media } from '@signicat/designi/helpers/responsive';
import { SPACE } from '@signicat/designi/constants/style';
import { Feature } from '@signiapp/core/components';
import { create } from "../../store/actions";
import { t } from "../../helpers/i18n";
import { REMINDERS } from "../../constants/order";
import { order as orderValidator } from "../../store/validators";
var Options = /*#__PURE__*/forwardRef(function (props, ref) {
  var _orderState$uiFeature, _orderState$uiFeature2, _orderState$notificat, _orderState$notificat2, _orderState$notificat3, _orderState$notificat4, _orderState$advanced, _orderState$advanced2, _orderState$advanced3;
  var dispatch = useDispatch();
  var history = useHistory();

  // const validation = useSelector((state) => (state.create.validation));
  var orderState = useSelector(function (state) {
    return state.create.data;
  });
  var _useSelector = useSelector(function (state) {
      return state.create;
    }),
    features = _useSelector.features;
  var validationOptions = {
    minExpirationDate: addDays(new Date(), 1).toISOString(),
    maxExpirationDate: orderState.uiFeatures.maxExpires
  };
  var validation = orderValidator(orderState, validationOptions);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    validateAll = _useState2[0],
    setValidateAll = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    customRemindersEnabled = _useState4[0],
    setCustomRemindersEnabled = _useState4[1];
  var handleDateChange = function handleDateChange(date) {
    if (!date) {
      dispatch({
        type: 'ORDER_UPDATE_FIELD',
        field: 'expires',
        value: null
      });
      return;
    }
    try {
      var dateObject = new Date(date);
      var maxExpiresObject = new Date(orderState.uiFeatures.maxExpires);
      var now = new Date();
      dateObject.setHours(now.getHours(), now.getMinutes(), now.getSeconds());

      // Ensure expiration date does not exceed max expiration date
      if (dateObject > maxExpiresObject) {
        dateObject.setTime(maxExpiresObject.getTime());
      }
      dispatch({
        type: 'ORDER_UPDATE_FIELD',
        field: 'expires',
        value: dateObject.toISOString()
      });
    } catch (err) {
      dispatch({
        type: 'ORDER_UPDATE_FIELD',
        field: 'expires',
        value: date
      });
    }
  };
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSending = _useState6[0],
    setIsSending = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    errors = _useState8[0],
    setErrors = _useState8[1];
  useImperativeHandle(ref, function () {
    return {
      handleSendClick: function handleSendClick() {
        if (Object.entries(validation).length > 0) {
          setValidateAll(true);
          return;
        }
        setIsSending(true);
        dispatch(create.createAndSend()).then(function () {
          setIsSending(false);
          history.push('sent');
        })["catch"](function (err) {
          var _err$body$message, _err$body;
          console.error(err);
          setIsSending(false);
          setValidateAll(true);
          var message = (_err$body$message = (_err$body = err.body) === null || _err$body === void 0 ? void 0 : _err$body.message) !== null && _err$body$message !== void 0 ? _err$body$message : 'unknown_sending_error_title';
          setErrors([{
            message: message
          }]);
        });
      }
    };
  });
  var handleContactChange = function handleContactChange(e) {
    dispatch({
      type: 'ORDER_UPDATE_CONTACT',
      field: 'email',
      value: e.target.value
    });
  };
  var handleOrderChange = function handleOrderChange(field) {
    return function (e) {
      dispatch({
        type: 'ORDER_UPDATE_FIELD',
        field: field,
        value: e.target.value
      });
    };
  };
  var handleRemindersChange = function handleRemindersChange(e) {
    var selectedReminders = e.target.value;
    dispatch({
      type: 'ORDER_UPDATE_REMINDERS',
      value: selectedReminders
    });
  };
  var handleAuthorNotificationChange = function handleAuthorNotificationChange(e) {
    var selectedNotifications = e.target.value ? [e.target.value] : '';
    dispatch({
      type: 'ORDER_UPDATE_AUTHOR_NOTIFICATIONS',
      value: selectedNotifications
    });
  };
  var handleNumberOfSignersChange = function handleNumberOfSignersChange(e) {
    var numberOfSigners = Number(e.target.value);
    dispatch({
      type: 'ORDER_UPDATE_NUMBER_OF_SIGNERS',
      value: numberOfSigners
    });
  };
  var handleTitleChange = function handleTitleChange(e) {
    dispatch({
      type: 'ORDER_UPDATE_TITLE',
      value: e.target.value
    });
  };
  var handleDescriptionChange = function handleDescriptionChange(e) {
    dispatch({
      type: 'ORDER_UPDATE_DESCRIPTION',
      value: e.target.value
    });
  };
  var numberOfSigners = orderState.signers.length;
  var numberOfRequiredSigners = orderState.signers.filter(function (signer) {
    return signer.data.required;
  }).length;
  var numberOfRequiredSignersOptions = _toConsumableArray(new Array(numberOfSigners)).map(function (item, index) {
    return index + 1;
  }).map(function (item, index) {
    return {
      value: item,
      text: item,
      disabled: item < numberOfRequiredSigners
    };
  });
  var remindersOptions = REMINDERS.map(function (r) {
    return {
      value: r,
      text: t("reminders_".concat(r))
    };
  });
  var authorNotificationOptions = [{
    value: null,
    text: ''
  }].concat(_toConsumableArray((_orderState$uiFeature = orderState.uiFeatures.allowedAuthorReceipts) === null || _orderState$uiFeature === void 0 ? void 0 : _orderState$uiFeature.map(function (v) {
    return {
      value: v,
      text: t("author_notification_".concat(v === null || v === void 0 ? void 0 : v.toLowerCase()))
    };
  })));
  var handleBlur = function handleBlur(fieldName) {
    return function () {
      dispatch({
        type: 'OPTIONS_FORM_BLUR',
        field: fieldName
      });
    };
  };
  var handleForwardingChange = function handleForwardingChange(e) {
    dispatch({
      type: 'ORDER_SET_USE_FORWARDING',
      value: e.target.checked
    });
  };
  var isSequentialSigning = function isSequentialSigning() {
    return numberOfRequiredSignersOptions.length === 0 || orderState.signers.some(function (s) {
      return s.data.order && s.data.order !== 0;
    });
  };
  return /*#__PURE__*/React.createElement(Column, {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Form, {
    validation: validation,
    state: {
      validateAll: validateAll
    }
  }, errors && errors.length ? /*#__PURE__*/React.createElement(Message, {
    variant: "error"
  }, errors.map(function (error) {
    return /*#__PURE__*/React.createElement("div", {
      key: btoa(error.message)
    }, t(error.message));
  })) : null, validateAll && validation.documents ? validation.documents.errors.map(function (err) {
    return /*#__PURE__*/React.createElement(Message, {
      key: btoa(err),
      variant: "error"
    }, err);
  }) : null, validateAll && validation.signers ? validation.signers.errors.map(function (err) {
    return /*#__PURE__*/React.createElement(Message, {
      key: btoa(err),
      variant: "error"
    }, err);
  }) : null, /*#__PURE__*/React.createElement(Row, {
    marginBottom: SPACE.lg
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Field, {
    name: "title",
    helpText: t('signorder_field_title_helptext')
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('signorder_field_title_label'),
    onChange: handleTitleChange,
    value: orderState.metaData.title || '',
    name: "title",
    inputProps: {
      maxLength: 255
    }
  })))), /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(TextField, {
    label: "".concat(t('signorder_field_description_label'), " (").concat(t('form_label_suffix_optional'), ")"),
    onChange: handleDescriptionChange,
    value: orderState.metaData.description || '',
    name: "description"
  }))), /*#__PURE__*/React.createElement(Segment, {
    divided: true,
    direction: media.matches.mobile.and('down') ? 'column' : 'row',
    marginBottom: "32px",
    size: "lg",
    space: media.matches.mobile.and('down') ? 'lg' : 'xxl',
    heading: t('signorder_section_options'),
    notchedHeading: true,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Heading, {
    level: 5
  }, t('signorder_field_expiration_heading')), /*#__PURE__*/React.createElement(Field, {
    name: "expires"
  }, /*#__PURE__*/React.createElement(DateField, {
    label: t('signorder_field_expiration_label'),
    disablePast: true,
    value: orderState.expires || '',
    onChange: handleDateChange,
    initialFocusedDate: orderState.expires || orderState.uiFeatures.maxExpires,
    minDate: addDays(new Date(), 1),
    maxDate: orderState.uiFeatures.maxExpires,
    fullWidth: true
  })), /*#__PURE__*/React.createElement(HelpText, null, t('signorder_field_expiration_helptext', {
    maxExpirationDate: format(new Date(orderState.uiFeatures.maxExpires), 'dd.MM.yyyy')
  })))), ((_orderState$uiFeature2 = orderState.uiFeatures.allowedAuthorReceipts) === null || _orderState$uiFeature2 === void 0 ? void 0 : _orderState$uiFeature2.length) > 0 ? /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Heading, {
    level: 5
  }, t('signorder_field_authornotifications_heading')), /*#__PURE__*/React.createElement(Select, {
    label: t('signorder_field_authornotifications_label'),
    options: authorNotificationOptions,
    onChange: handleAuthorNotificationChange,
    value: (_orderState$notificat = (_orderState$notificat2 = orderState.notificationSettings) === null || _orderState$notificat2 === void 0 ? void 0 : _orderState$notificat2.sendReceiptsToAuthor[0]) !== null && _orderState$notificat !== void 0 ? _orderState$notificat : ''
  }), /*#__PURE__*/React.createElement(HelpText, null, t('signorder_field_author_notifications_helptext')))) : null), /*#__PURE__*/React.createElement(Feature, {
    featureId: "signature_custom_reminders",
    onFeatureToggle: function onFeatureToggle(e) {
      return setCustomRemindersEnabled(e);
    }
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Heading, {
    level: 5
  }, t('signorder_field_reminders_heading')), /*#__PURE__*/React.createElement(Select, {
    label: t('signorder_field_reminders_label'),
    disabled: !customRemindersEnabled,
    options: remindersOptions,
    onChange: handleRemindersChange,
    value: orderState === null || orderState === void 0 ? void 0 : (_orderState$notificat3 = orderState.notificationSettings) === null || _orderState$notificat3 === void 0 ? void 0 : _orderState$notificat3.reminder,
    testSelector: "reminders-frequency"
  }), /*#__PURE__*/React.createElement(HelpText, null, t('signorder_field_reminders_helptext', {
    notificationsLimit: orderState === null || orderState === void 0 ? void 0 : (_orderState$notificat4 = orderState.notificationSettings) === null || _orderState$notificat4 === void 0 ? void 0 : _orderState$notificat4.maxNumberOfReminders
  })))))), (orderState === null || orderState === void 0 ? void 0 : (_orderState$advanced = orderState.advanced) === null || _orderState$advanced === void 0 ? void 0 : _orderState$advanced.stack) !== 'green' ? /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Heading, {
    level: 5
  }, t('signorder_field_completion_heading')), /*#__PURE__*/React.createElement(Select, {
    label: t('signorder_field_completion_label'),
    options: numberOfRequiredSignersOptions,
    onChange: handleNumberOfSignersChange,
    value: (orderState === null || orderState === void 0 ? void 0 : (_orderState$advanced2 = orderState.advanced) === null || _orderState$advanced2 === void 0 ? void 0 : _orderState$advanced2.numberOfSigners) || numberOfSigners,
    disabled: isSequentialSigning(),
    testSelector: "number-of-signers"
  }), /*#__PURE__*/React.createElement(HelpText, null, isSequentialSigning() ? t('signorder_field_completion_helptext_disabled') : t('signorder_field_completion_helptext'))))) : null, features.forwarding.available ? /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Row, {
    marginBottom: "12px"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Heading, {
    level: 5
  }, t('signorder_option_forwarding_heading')), /*#__PURE__*/React.createElement(Toggle, {
    label: t('signorder_option_forwarding_label'),
    helpText: t('signorder_option_forwarding_helptext'),
    disabled: features.forwarding.disabled,
    checked: (_orderState$advanced3 = orderState.advanced) === null || _orderState$advanced3 === void 0 ? void 0 : _orderState$advanced3.useForwarding,
    onChange: handleForwardingChange
  })))) : null), /*#__PURE__*/React.createElement(Modal, {
    open: isSending
  }, /*#__PURE__*/React.createElement(Spinner, null))));
});
export default Options;